<template>
    <div class="contentSelection" v-if="dataItem && dataItem.length > 0">
      <!--热门推荐
       1 临床好课  2图文资讯  4 直播（单/专栏：单场直播预告/回放/直播中） 6 病例实战  13 专题
       14 会议微网站 30 医学专栏
        -->
        <div v-if="layoutType == 1">
          <div v-for="(item, index) in dataItem" :key="index">
            <layout1Course v-if="item.origin_type === 1" :dataItem="item"/>
            <layout1Article v-if="item.origin_type === 2" :dataItem="item" />
            <layout1Lives v-if="item.origin_type === 4" :dataItem="item" />
            <layout1Case v-else-if="item.origin_type === 6" :dataItem="item" />
            <layout1Guide v-else-if="item.origin_type === 9" :data-item="item"/>
            <layout1Special v-else-if="item.origin_type === 13" :dataItem="item" />
<!--            <layout1Academic v-else-if="item.origin_type === 14" :dataItem="item" />-->
            <layout1Medicine v-else-if="item.origin_type === 30" :dataItem="item" />
          </div>
        </div>
        <div v-else-if="layoutType == 3" class='layout3'>
        <div v-for="(item, index) in dataItem" :key="index" style="display: inline-block">
          <layout3Course v-if="item.origin_type === 1" :dataItem="item" :index="index"/>
          <layout3Article v-if="item.origin_type === 2" :dataItem="item" :index="index"/>
          <layout3Lives v-if="item.origin_type === 4" :dataItem="item" :index="index"/>
          <layout3Case v-else-if="item.origin_type === 6" :dataItem="item" :index="index"/>
          <layout3Special v-else-if="item.origin_type === 13" :dataItem="item" :index="index"/>
          <layout3Academic v-if="item.origin_type === 14" :dataItem="item" :index="index"/>
          <layout3Medicine v-else-if="item.origin_type === 31" :dataItem="item" :index="index"/>
        </div>
      </div>
    </div>
</template>

<script>
import {
  layout1Course,
  layout1Article,
  layout1Lives,
  layout1Case,
  layout1Guide,
  layout1Special,
  layout1Medicine,
  layout1Academic,
  layout3Course,
  layout3Lives,
  layout3Academic,
  layout3Article,
  layout3Case,
  layout3Special,
  layout3Medicine
} from './index.js'

export default {
    name: 'contentSelection',
    components: {
      layout1Course,
      layout1Article,
      layout1Case,
      layout1Guide,
      layout1Medicine,
      layout1Lives,
      layout1Academic,
      layout1Special,
      layout3Course,
      layout3Lives,
      layout3Academic,
      layout3Article,
      layout3Case,
      layout3Special,
      layout3Medicine
    },
    props: {
        dataItem: {
            type: Array,
            default: () => [],
            required: true
        },
        layoutType: {
          type: Number,
          default: 0
        }
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
    .layout3{
        padding: 0 12px 18px 12px
    }
</style>



// WEBPACK FOOTER //
// src/components/hotRecommend/index.vue